<button mat-button [class]="'commonButton ' + cssClass " (click)="notificarClick()" type="button" [disabled]="disabledButton">
  {{label | translate }}
</button>

